import { inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  readonly title?: string;
  readonly message?: string;
  readonly confirm?: {
    text: string;
    class: string;
  };
  readonly cancelText?: string;
}

export abstract class AbstractDialogAuraComponent<TData extends DialogData = DialogData> {
  protected readonly data = inject<TData>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<this>);

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
